import React from "react";
import { Spinner } from "reactstrap";

function LightSpinner({ isCentered }: { isCentered?: boolean }) {
    let className = "default-spinner";
    className += isCentered === true ? " centered-spinner" : "";

    return (
        <Spinner color="light" className={className} />
    );
}

export default LightSpinner;
